import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { addLoadedComponentAction } from '../Coachmark/redux/actions';

const Fallback = ({ componentName, addLoadedComponent }) => {
  useEffect(
    () => () => {
      addLoadedComponent(componentName);
    },
    [componentName]
  );
  return <div />;
};

const mapDispatchToProps = {
  addLoadedComponent: addLoadedComponentAction,
};

export default connect(null, mapDispatchToProps)(Fallback);
